
import { Component, Prop, Vue } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';
import { getDepartmentList, joinCompany } from '@/api/company';
import { UserModule } from '../../../store/modules/user';
import { parseTime } from '../../../utils/index';
import { setUserDept } from '@/api/users';

@Component({
  name: 'SetDepartmentDialog',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })setDepartmentVisible!:Boolean;

  @Prop({
    type: Array,
    default: () => []
  })setDepartmentData!:[];

  @Prop({
    type: Number,
    default: 1
  })type!:Number;
  @Prop({
    type: Object,
    default: () => {}
  })orderDetail!:any;

  private formSearch = {
    name: ''
  }

  private loadMore = false;
  private page = 1;
  private selected = ''

  // 省市区元数据
  private lAreaData = lAreaData;
  private defaultProps:any = {
    children: 'child',
    label: 'name',
    value: 'id'
  }
  // 保存返回数据
  private selectAreaBean:any={}

  private changeHandle(value: any) {
    this.selectAreaBean = {
      province: this.selected[0],
      province_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[0],
      city: this.selected[1],
      city_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[1],
      district: this.selected[2],
      district_name: (this.$refs.myCascader as any).getCheckedNodes()[0].pathLabels[2],
      adcode: (this.$refs.myCascader as any).getCheckedNodes()[0].data.adcode
    };
  }

  // 搜索
  handleSearch() {
    this.page = 1
    this.departmentId = [];
    this.getDepartmentList();
  }

  // 清空
  handleClear() {
    this.page = 1;
    this.formSearch.name = ''
    this.selected = '';
    this.selectAreaBean = {};
    this.departmentId = [];
    this.getDepartmentList();
  }

  private departmentId = []
  private tableData = []

  created() {
    this.lAreaData.map((item:any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item && item.child && item.child.map((temp:any) => {
          if (temp && temp.child && temp.child.length === 0) {
            (temp.child as any) = undefined;
          }
        });
      }
    });
    this.getDepartmentList();
  }
  // 获取部门
  getDepartmentList() {
    const params = {
      name: this.formSearch.name,
      company_id: UserModule.getCompanyId,
      type: '9', // type=9 查所有部门  type=2查服务部门
      page: this.page,
      ...this.selectAreaBean
    };
    getDepartmentList(params)
      .then(res => {
        if (res.data) {
          this.tableData = (res as any).data.list;
          this.paseData(this.tableData);
        } else {
          this.tableData = [];
        }
        if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
          this.loadMore = true;
        } else {
          this.loadMore = false;
        }
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }
  paseData(val:any) {
    for (let i = 0; i < val.length; i++) {
      let cont:any = val[i];
      cont.area = val[i].province_name + val[i].city_name + val[i].district_name;
      cont.addTimeStr = parseTime(cont.addtime, '{y}-{m}-{d} {h}:{i}');
      this.$set(this.tableData, cont, i);
    }
  }
  // 加载更多
  moreData() {
    this.page = this.page++;
    this.getDepartmentList();
  }

  save() {
    if (this.type === 2) {
      this.jionCompany()
    } else {
      this.setUserDept();
    }
  }

  setUserDept() {
    var userStr = '';
    for (var user of this.setDepartmentData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    var deptStr = '';
    for (var dept of this.departmentId) {
      deptStr += dept + ',';
    }
    deptStr = deptStr.substr(0, deptStr.length - 1);
    if (deptStr.length === 0) {
      this.$notify.error({
        title: '提示',
        message: '请选择部门'
      });
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      department_str: deptStr,
      user_str: userStr
    };
    setUserDept(params)
      .then(res => {
        this.$notify.success({
          title: '提示',
          message: '设置成功',
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center'
        });
        this.addSuccess();
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }
  private jionCompany() {
    let params:any = {
      user_id: this.orderDetail.order.create_user_id,
      company_id: UserModule.getCompanyId,
    };
    if (this.departmentId && this.departmentId.length > 0) {
      let deptStr = '';
      for (var dept of this.departmentId) {
        deptStr += dept + ',';
      }
      deptStr = deptStr.substr(0, deptStr.length - 1);
      params.department_str = deptStr
    }
    joinCompany(params)
      .then(res => {
        this.$notify.success({
          title: '提示',
          message: '加入成功',
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center'
        });
        this.addSuccess();
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }

  close() {
    this.$emit('close', false);
  }

  addSuccess() {
    this.$emit('setDeptSuccess', false);
  }
}
